module.exports = __webpack_public_path__ + "static/media/06.792499de.png";